import { render, staticRenderFns } from "./JPopup.vue?vue&type=template&id=1b7791d3&scoped=true"
import script from "./JPopup.vue?vue&type=script&lang=js"
export * from "./JPopup.vue?vue&type=script&lang=js"
import style0 from "./JPopup.vue?vue&type=style&index=0&id=1b7791d3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7791d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b7791d3')) {
      api.createRecord('1b7791d3', component.options)
    } else {
      api.reload('1b7791d3', component.options)
    }
    module.hot.accept("./JPopup.vue?vue&type=template&id=1b7791d3&scoped=true", function () {
      api.rerender('1b7791d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JPopup.vue"
export default component.exports